import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { api } from "../../../services/api/axios";

const fetchCryptoNetworks = async () => {
  const { data } = await api.get("/v1/admin/business/crypto-networks");
  return data.data;
};

export const useCryptoNetworks = () => {
  return useQuery({
    queryKey: ["crypto-networks"],
    queryFn: fetchCryptoNetworks,
    refetchOnWindowFocus: false,
  });
};

const runCheck = async () => {
  const { data } = await api.post("/v1/admin/business/crypto-networks/check");
  return data.data;
};

export const useRunCryptoNetworkCheck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: runCheck,
    onSuccess: (results) => {
      queryClient.invalidateQueries({ queryKey: ["crypto-networks"] });
      const down = results.filter((r) => r.status !== "ok");
      if (down.length > 0) {
        toast.error(`${down.length} network(s) unavailable: ${down.map((r) => `${r.currency}/${r.symbol}`).join(", ")}`);
      } else {
        toast.success("All networks are available");
      }
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Network check failed");
    },
  });
};

const setEnabled = async ({ uuid, isEnabled }) => {
  const { data } = await api.patch(`/v1/admin/business/crypto-networks/${uuid}`, { isEnabled });
  return data.data;
};

export const useToggleCryptoNetwork = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: setEnabled,
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ["crypto-networks"] });
      toast.success(
        `${result.currency.toUpperCase()} on ${result.symbol.toUpperCase()} ${result.isEnabled ? "resumed" : "paused"}`,
      );
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Could not update the network");
    },
  });
};
